import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import { api, shortAddr, formatEth, formatNumber } from "@/lib/api";
import { Wallet } from "lucide-react";

export default function Accounts() {
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    api.get("/accounts/top", { params: { limit: 100 } })
      .then((r) => { setItems(r.data.items); setTotal(r.data.total); });
  }, []);

  return (
    <Layout>
      <div className="flex items-center gap-3 mb-2">
        <Wallet className="text-[var(--ks-primary)]" />
        <h1 className="text-xl font-semibold" data-testid="accounts-title">Top Accounts</h1>
      </div>
      <p className="text-sm text-[var(--ks-text-soft)] mb-4">
        Top {items.length} of {formatNumber(total)} accounts by ETH balance.
      </p>
      <div className="ks-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="ks-table" data-testid="accounts-table">
            <thead>
              <tr>
                <th>Rank</th>
                <th>Address</th>
                <th className="text-right">Balance</th>
                <th className="text-right">Txns</th>
                <th className="text-right">Tokens</th>
              </tr>
            </thead>
            <tbody>
              {items.map((a) => (
                <tr key={a.address} data-testid={`account-row-${a.address}`}>
                  <td className="text-[var(--ks-text-soft)]">#{a.rank}</td>
                  <td>
                    <Link to={`/address/${a.address}`} className="ks-link mono">
                      {shortAddr(a.address)}
                    </Link>
                  </td>
                  <td className="text-right font-medium">{formatEth(a.eth_balance, 6)} ETH</td>
                  <td className="text-right">{formatNumber(a.tx_count)}</td>
                  <td className="text-right">{a.token_count}</td>
                </tr>
              ))}
              {items.length === 0 && (
                <tr><td colSpan={5} className="text-center py-8 text-[var(--ks-text-soft)]">No accounts found.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
}
